import ActionType from 'actions/ActionType'
import { update } from 'actions/data'

export const addSubcriteria = payload => dispatch =>
  dispatch({ type: ActionType.Campaign.ADD_SUBCRITERIA, payload })

export const removeSubcriteria = payload => dispatch =>
  dispatch({ type: ActionType.Campaign.REMOVE_SUBCRITERIA, payload })

export const toggleFormDataPanel = (payload) => (dispatch) =>
	dispatch({ type: ActionType.Campaign.TOGGLE_FORM_DATA_PANEL, payload })

export const receiveCampaign = payload => dispatch => {
	dispatch({
		type: ActionType.Campaign.RECEIVE_CAMPAIGN,
		payload,
	})
}

export const addStage =
	(payload = '') =>
  dispatch =>
		dispatch({ type: ActionType.Campaign.ADD_STAGE, payload })

export const addStageSuccess = payload => dispatch =>
	dispatch({ type: ActionType.Campaign.ADD_STAGE_SUCCESS, payload })

export const changeStageName = payload => dispatch =>
	dispatch({ type: ActionType.Campaign.CHANGE_STAGE_NAME, payload })

export const changeNewStageName = payload => dispatch =>
	dispatch({ type: ActionType.Campaign.CHANGE_NEW_STAGE_NAME, payload })

export const toggleFunnelCalendarView = payload => dispatch =>
	dispatch({ type: ActionType.Campaign.TOGGLE_FUNNEL_CALENDAR_VIEW, payload })

export const toggleCalendarListView = payload => dispatch =>
	dispatch({ type: ActionType.Campaign.TOGGLE_CALENDAR_LIST_VIEW, payload })

export const toggleDateRange = payload => dispatch =>
	dispatch({ type: ActionType.Campaign.TOGGLE_DATE_RANGE, payload })

export const handleFieldChange = payload => dispatch =>
	dispatch({ type: ActionType.Campaign.CHANGE_FIELD, payload })

export const addNewTaskToCampaign = payload => dispatch =>
	dispatch({ type: ActionType.Campaign.ADD_NEW_TASK_TO_CAMPAIGN, payload })

export const addOrEditEventGoal = payload => dispatch =>
	dispatch({
    type: ActionType.Campaign.ADD_OR_EDIT_EVENT_GOAL,
		payload,
	})

export const addTaskToCampaign = (payload) => (dispatch) =>
	dispatch({ type: ActionType.Campaign.ADD_TASK_TO_CAMPAIGN, payload })

export const addEventGoalToCampaign = (payload) => (dispatch) =>
	dispatch({ type: ActionType.Campaign.ADD_EVENT_GOAL_TO_CAMPAIGN, payload })

export const expandFunnelStage = (payload) => (dispatch) => {
	dispatch({ type: ActionType.Campaign.EXPAND_FUNNEL_STAGE, payload })
	return Promise.resolve()
}

export const toggleTaskModal = (payload) => (dispatch, getState) => {
	const currentCampaign = getState().campaign.addOrEdit.campaign
	// console.log(currentCampaign)
	// console.log(payload)

	// there's no stage id
	const stage =
		payload && Number.isInteger(payload.stageIdx)
			? {
					label: currentCampaign.stages[payload.stageIdx].name,
					value: currentCampaign.stages[payload.stageIdx].id,
					key: `sampleStage${
						currentCampaign.stages[payload.stageIdx].id
					}StageTaskFormSelect`,
			  }
			: null

	const campaign =
		payload && (Number.isInteger(payload.stageIdx) || currentCampaign)
			? {
					label: currentCampaign.fields.name,
					value: currentCampaign.id,
					key: `${currentCampaign.id}CampaignTaskFormSelect`,
			  }
			: null

	const taskID = (payload && payload.taskID) || null

	return dispatch({
		type: ActionType.Campaign.TOGGLE_TASK_MODAL,
		payload: payload
			? {
					...payload,
					stage,
					campaign,
					taskID,
			  }
			: null,
	})
}

export const addPlaceholderTask =
	(payload, stageIdx, display_name = '') =>
	(dispatch, getState) => {
		const campaign = getState().campaign.addOrEdit.campaign

		const placeholderID = `placeholder_${campaign.placeholderTasks.index}`

		const stageName = campaign?.stages?.[stageIdx]?.name
		const indexInStage = campaign.stages?.[stageIdx]?.tasks?.length
		const name = `#${indexInStage + 1 || '?'} ${display_name} in campaign '${
			campaign?.fields?.name
		}', in stage '${stageName || 'Unknown'}'`

		dispatch({
			type: ActionType.Campaign.ADD_PLACEHOLDER_TASK,
			payload: { ...payload, name },
			stageIdx,
			placeholderID,
		})
	}

export const replacePlaceholderTask = (payload) => (dispatch) => {
	return dispatch({
		type: ActionType.Campaign.REPLACE_PLACEHOLDER_TASK,
		payload,
	})
}

export const moveStageTask = (stageIdx, dragIndex, hoverIndex) => (dispatch) =>
	dispatch({
		type: ActionType.Campaign.MOVE_STAGE_TASK,
		stageIdx,
		dragIndex,
		hoverIndex,
	})

export const moveStage = (dragIndex, hoverIndex) => (dispatch) =>
	dispatch({
		type: ActionType.Campaign.MOVE_STAGE,
		dragIndex,
		hoverIndex,
	})

export const deleteStage = (stageIdx) => (dispatch) =>
	dispatch({ type: ActionType.Campaign.DELETE_STAGE, stageIdx })

export const removeEventGoal = (stageIdx, eventGoalIdx) => (dispatch) =>
	dispatch({
		type: ActionType.Campaign.REMOVE_EVENT_GOAL,
		stageIdx,
		eventGoalIdx,
	})

export const removeNewEventGoal = () => (dispatch) =>
	dispatch({ type: ActionType.Campaign.REMOVE_NEW_EVENT_GOAL })

export const removeStageTask = (stageIdx, taskIdx) => (dispatch) =>
	dispatch({ type: ActionType.Campaign.REMOVE_STAGE_TASK, stageIdx, taskIdx })

export const updateStatus =
  (currentStatus, campaignID) => (dispatch, getState) => {
    const id = campaignID || getState().campaign.addOrEdit.campaign.id
    const currentToNextStatusMap = { W: 'L', L: 'P', P: 'L' }
    const newStatus = currentToNextStatusMap[currentStatus]

    dispatch({
      type: ActionType.Campaign.UPDATE_STATUS_REQUEST,
      id,
      currentStatus,
    })

    return Promise.resolve(
      dispatch(update(null, 'campaign', `/${id}/status/${newStatus}`)),
    ).then(
      () =>
        dispatch({
          type: ActionType.Campaign.UPDATE_STATUS_SUCCESS,
          newStatus,
        }),
      // (err) =>
      //   dispatch({ type: ActionType.Data.UPDATE_FAILURE, entityType: 'campaign', payload: err, newStatus }),
    )
  }

export const clickBottomNavigation = (payload) => (dispatch) =>
	dispatch({ type: ActionType.Campaign.CLICK_BOTTOM_NAVIGATION, payload })

export const toggleBottomNav =
	(payload = null) =>
	(dispatch) =>
		dispatch({ type: ActionType.Campaign.TOGGLE_BOTTOM_NAV, payload })

export const clickContactCount =
	(payload = null) =>
	(dispatch) =>
		dispatch({ type: ActionType.Campaign.CLICK_CONTACT_COUNT, payload })

export const ingestPrediction = (payload) => (dispatch) => {
	dispatch({ type: ActionType.Campaign.INGEST_PREDICTION, payload })
}

export const selectEventGoal = (payload) => (dispatch) =>
	dispatch({ type: ActionType.Campaign.SELECT_EVENT_GOAL, payload })

export const changeSubentity = (payload, subIdx, customFormQuestion) => dispatch =>
  dispatch({ type: ActionType.Campaign.CHANGE_SUBENTITY, payload, subIdx, customFormQuestion })

export const changeSubentityValue = (payload, subIdx) => dispatch =>
  dispatch({
    type: ActionType.Campaign.CHANGE_SUBENTITY_VALUE,
    payload,
    subIdx,
  })

export const changeOperator = (payload, subIdx) => dispatch =>
  dispatch({ type: ActionType.Campaign.CHANGE_OPERATOR, payload, subIdx })

export const changeEntity = (payload) => (dispatch) =>
  dispatch({ type: ActionType.Campaign.CHANGE_ENTITY, payload })

export const changeCustomField = (payload, subIdx) => dispatch =>
  dispatch({ 
    type: ActionType.Campaign.CHANGE_CUSTOM_FIELD, 
    payload,
    subIdx,
  })
